import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

import { Link } from "../../../components/Link";
import { IProduct } from "../../../models/catalogue";
import { ICompareTile } from "../../../models/product-compare";
import { trackSelectItemEvent } from "../../../utils/analytics";
import { useProductCompareAnalytics } from "../analytics";
import { getShopNowURL } from "../selectors";

type IProps = Immutable<{
    tile: ICompareTile;
    selectedVariant: IProduct | null;
    visibleOverride?: boolean;
}>;

export const ShopNowLink = (props: IProps) => {
    const { listMetadata } = useProductCompareAnalytics();

    if (!props.selectedVariant) {
        return null;
    }

    const url = getShopNowURL(props.tile, props.selectedVariant);
    return (
        <Link
            href={url}
            className="button al-comparisongrid-shopnow"
            onClick={() => {
                trackSelectItemEvent(props.selectedVariant, listMetadata);
            }}
        >
            {props.visibleOverride ? t`Explore` : t`Shop Now`}
            <span className="ada-screenreader-only">
                {interpolate(t`for %(productName)s`, {
                    productName: props.selectedVariant?.title || "",
                })}
            </span>
        </Link>
    );
};
